<div class="buttons__row">
  <button mat-raised-button
          (click)="onPreviewClick()" data-cy="button-form-actions-preview">
    Prévisualiser
  </button>
  <span style="border-left: 1px solid #9a9a9a; height: 36px; margin-left: 20px; margin-right: 20px;"></span>
  <button mat-raised-button style="margin-right: 8px;"
          color="accent"
          matTooltip="Sauvegarder le formulaire en tant que brouillon, vous pourrez le publier dans la visualisation le cas échéant"
          [disabled]="isDisabled"
          (click)="onSubmitForm()" data-cy="button-form-actions-save">
    Sauvegarder
  </button>
</div>
